import { Check } from "lucide-react";
import { Chip, usd } from "@/components/common";
import { cn } from "@/lib/utils";

// A plan on sale, on /pricing and in the founder's Store, as the design handoff draws it (Store.dc.html): its name, the
// price large with its period small, three lines (credits, server, support), and its action at the bottom. The plan
// you're on carries YOUR PLAN and a 2px edge laid over the card. With seats (FEATURE_WALLET; design_handoff_team_roles
// screen 12) it lists the plan's team member seats, independent professionals and investors too.
export const serverLine = (s) => s?.label && `${/server/i.test(s.label) ? s.label : `${s.label} server`}, ${s.max_active_sessions} sessions at once`
  + (s.by_hand ? ", a dedicated machine set up with you" : s.dedicated ? ", dedicated vCPUs" : "");

export default function PlanCard({ plan, current, children, className, ...props }) {
  const [amount, period] = (plan.display_price || "").split(/(?=\/)/);
  const features = [
    `${usd(plan.monthly_credits_usd)} of credits every month`,
    serverLine(plan.server),
    plan.seats != null && `${plan.seats} team member seats`,
    plan.pros != null && `${plan.pros} independent professionals`,
    plan.seats != null && "Investors: unlimited",
    plan.support_text,
  ].filter(Boolean);
  return (
    <div className={cn("relative bg-card rounded-[10px] p-[18px] flex flex-col gap-2.5", className)} {...props}>
      {current && <span className="absolute inset-0 border-2 border-foreground rounded-[10px] pointer-events-none" aria-hidden="true" />}
      <div className="flex justify-between items-baseline gap-2">
        <span className="font-display text-[15px] tracking-[0.02em] font-semibold">{plan.name}</span>
        {current && <Chip className="py-0 leading-[18px]">Your plan</Chip>}
      </div>
      <div className="flex items-baseline gap-1 tabular-nums">
        <span className="text-[24px] leading-7">{amount}</span>
        <span className="text-muted-foreground">{period === "/month" || !period ? "a month" : period.replace(/^\//, "a ")}</span>
      </div>
      <ul className="m-0 p-0 list-none flex flex-col gap-1.5 text-sm text-gr-ink-secondary">
        {features.map((f) => (
          <li key={f} className="flex gap-2"><Check className="w-3.5 h-3.5 mt-0.5 shrink-0 text-muted-foreground" aria-hidden="true" />{f}</li>
        ))}
      </ul>
      {children && <div className="mt-auto pt-1.5">{children}</div>}
    </div>
  );
}
